import {
  CREATE_POD,
  CREATE_POD_FAILURE,
  CREATE_POD_SUCCESS,
  DELETE_POD,
  DELETE_POD_FAILURE,
  DELETE_POD_SUCCESS,
  GET_POD,
  GET_POD_FAILURE,
  GET_POD_SUCCESS,
  LOGOUT_SUCCESS,
  PERMANENT_POD_RETENTION,
  UPDATE_POD,
  UPDATE_POD_CONFIG,
  UPDATE_POD_CONFIG_FAILURE,
  UPDATE_POD_CONFIG_SUCCESS,
  UPDATE_POD_FAILURE,
  UPDATE_POD_SUCCESS,
} from "../../constants/types";

const INITIAL_POD_STATE = {
  loading: false,
  error: null,
  require_pod_approval: false,
  require_signature: false,
  require_parcel_photo: false,
  pod_retention_policy: PERMANENT_POD_RETENTION,
  allow_extra_pods: false,
  pods: [],
};

export function proofOfDeliveryReducer(state = INITIAL_POD_STATE, action) {
  switch (action.type) {
    case GET_POD:
      return { ...state, loading: true, error: null };
    case GET_POD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        pods: action.payload.pods,
        ...action.payload.configs,
      };
    case GET_POD_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CREATE_POD:
      return { ...state, loading: true, error: null };
    case CREATE_POD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case CREATE_POD_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case UPDATE_POD:
    case DELETE_POD:
      return { ...state, loading: true, error: null };
    case UPDATE_POD_SUCCESS:
      return { ...state, loading: false, error: null };
    case UPDATE_POD_FAILURE:
    case DELETE_POD_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_POD_SUCCESS:
      const pods = [...state.pods];
      const selectedPOD = pods.find((pod) => pod.id === action.payload);
      pods.splice(pods.indexOf(selectedPOD, 1));
      return { ...state, loading: false, pods };
    case UPDATE_POD_CONFIG:
      return { ...state, loading: true, error: null };
    case UPDATE_POD_CONFIG_SUCCESS:
      return { ...state, loading: false, error: null, ...action.payload };
    case UPDATE_POD_CONFIG_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case LOGOUT_SUCCESS:
      return INITIAL_POD_STATE;
    default:
      return state;
  }
}
